import { render, staticRenderFns } from "./AdminCollaborators.vue?vue&type=template&id=051176f0"
import script from "./AdminCollaborators.vue?vue&type=script&lang=js"
export * from "./AdminCollaborators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports